export default "__VITE_ASSET__$F8glWJA__"